'use client';

import { useEffect } from 'react';
import { useIdle } from 'react-use';
import Cookies from 'js-cookie';
import { useRouter } from 'next/navigation';

import useIsSignedIn from '@/hooks/useIsSignedIn';
import { trpc } from '@/trpc';
import { cleanupCookies } from '@/utils/cookies';
import { getRedirectUrl } from '@/utils';

const MIN = 60000; // 1 minute
const MAX_COUNT = parseInt(Cookies.get('idle-duration') ?? '15', 10); // 15 minutes

const ActivityDetector = () => {
  const { mutate } = trpc.auth.logout.useMutation();
  const router = useRouter();
  const { isSignedIn } = useIsSignedIn();
  const isIdle = useIdle(MIN * MAX_COUNT);

  useEffect(() => {
    if (isIdle && isSignedIn) {
      mutate(undefined, {
        onSuccess: () => {
          // Need to revisit here for the shared cookies cleanup after updating session management
          // For now, we are clearing the cookies to be expected to be removed
          cleanupCookies();
          router.push(getRedirectUrl('/session-timed-out'));
        }
      });
    }
  }, [isIdle, isSignedIn, router, mutate]);

  return null;
};

export default ActivityDetector;
